var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "event-modal" } },
    [
      _vm.getGoogleMeetLink()
        ? _c("div", { staticClass: "google-meet-btn" }, [
            _c(
              "a",
              { attrs: { href: _vm.getGoogleMeetLink(), target: "_blank" } },
              [
                _c("supsis-button", { attrs: { primary: "" } }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("videocam"),
                  ]),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("calendar.openGoogleMeet")) +
                      "\n            "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "meet-link-container" },
              [
                _c("span", { staticClass: "meet-link" }, [
                  _vm._v(_vm._s(_vm.getGoogleMeetLink())),
                ]),
                _vm._v(" "),
                _c("supsis-button", {
                  attrs: { xsmall: "", icon: "content_copy" },
                  on: { click: _vm.copyMeetLink },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.eventModalData.summary,
            expression: "eventModalData.summary",
          },
        ],
        staticClass: "event-input",
        attrs: { placeholder: _vm.$t("calendar.title") },
        domProps: { value: _vm.eventModalData.summary },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.eventModalData, "summary", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("span", { staticClass: "material-icons single" }, [
          _vm._v("access_time"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "custom-datetime-container" }, [
          _c("div", { staticClass: "datetime-row" }, [
            _c("label", { staticClass: "datetime-label" }, [
              _vm._v(_vm._s(_vm.$t("calendar.dateTimeStartLabel"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.startDateString,
                  expression: "startDateString",
                },
              ],
              staticClass: "custom-date-input",
              attrs: { type: "date" },
              domProps: { value: _vm.startDateString },
              on: {
                change: _vm.onStartDateStringChange,
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.startDateString = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            !_vm.eventModalData.isAllDay
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.startTimeString,
                      expression: "startTimeString",
                    },
                  ],
                  staticClass: "custom-time-input",
                  attrs: { type: "time" },
                  domProps: { value: _vm.startTimeString },
                  on: {
                    change: _vm.onStartTimeStringChange,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.startTimeString = $event.target.value
                    },
                  },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.eventModalData.isAllDay
            ? _c("div", { staticClass: "datetime-row" }, [
                _c("label", { staticClass: "datetime-label" }, [
                  _vm._v(_vm._s(_vm.$t("calendar.dateTimeEndLabel"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.endDateString,
                      expression: "endDateString",
                    },
                  ],
                  staticClass: "custom-date-input",
                  attrs: { type: "date" },
                  domProps: { value: _vm.endDateString },
                  on: {
                    change: _vm.onEndDateStringChange,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.endDateString = $event.target.value
                    },
                  },
                }),
              ])
            : _c("div", { staticClass: "datetime-row" }, [
                _c("label", { staticClass: "datetime-label" }, [
                  _vm._v(_vm._s(_vm.$t("calendar.dateTimeEndLabel"))),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.endDateString,
                      expression: "endDateString",
                    },
                  ],
                  staticClass: "custom-date-input",
                  attrs: { type: "date" },
                  domProps: { value: _vm.endDateString },
                  on: {
                    change: _vm.onEndDateStringChange,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.endDateString = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.endTimeString,
                      expression: "endTimeString",
                    },
                  ],
                  staticClass: "custom-time-input",
                  attrs: { type: "time" },
                  domProps: { value: _vm.endTimeString },
                  on: {
                    change: _vm.onEndTimeStringChange,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.endTimeString = $event.target.value
                    },
                  },
                }),
              ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "a-checkbox",
            {
              staticStyle: { width: "100px" },
              model: {
                value: _vm.eventModalData.isAllDay,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "isAllDay", $$v)
                },
                expression: "eventModalData.isAllDay",
              },
            },
            [_vm._v(_vm._s(_vm.$t("calendar.allDay")))]
          ),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              attrs: { "show-search": "" },
              model: {
                value: _vm.timezone,
                callback: function ($$v) {
                  _vm.timezone = $$v
                },
                expression: "timezone",
              },
            },
            _vm._l(_vm.timezones, function (tz, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: tz } },
                [_vm._v("\n                " + _vm._s(tz) + "\n            ")]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "a-select",
            {
              staticStyle: { width: "100%", "margin-top": "15px" },
              attrs: { "show-search": "" },
              on: { change: _vm.changeRepeat },
              model: {
                value: _vm.eventModalData.repeat,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "repeat", $$v)
                },
                expression: "eventModalData.repeat",
              },
            },
            _vm._l(_vm.repeatTimes, function (repeatTime, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: repeatTime.value } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(repeatTime.label) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "flex-end" } },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("people")]),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "5px" } }, [
                _vm._v(_vm._s(_vm.$t("calendar.agents"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%", "margin-left": "10px" },
              attrs: { "show-search": "", mode: "tags" },
              model: {
                value: _vm.eventModalData.refUsers,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "refUsers", $$v)
                },
                expression: "eventModalData.refUsers",
              },
            },
            _vm._l(_vm.usersClone, function (user, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: user._id } },
                [
                  _vm._v(
                    "\n                " + _vm._s(user.name) + "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "flex-end" } },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("person")]),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-left": "5px" } }, [
                _vm._v(_vm._s(_vm.$t("calendar.visitor"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%", "margin-left": "10px" },
              attrs: {
                "show-search": "",
                placeholder: _vm.$t("calendar.selectVisitorPlaceholder"),
                filterOption: false,
              },
              on: {
                focus: function ($event) {
                  return _vm.getVisitorsFunction()
                },
                search: _vm.getVisitorsFunction,
                click: function ($event) {
                  return _vm.getVisitorsFunction()
                },
              },
              model: {
                value: _vm.eventModalData.refVisitor,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "refVisitor", $$v)
                },
                expression: "eventModalData.refVisitor",
              },
            },
            _vm._l(_vm.visitors, function (visitor, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: visitor._id } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        !!visitor.fullname
                          ? visitor.fullname
                          : _vm.maskField("email", visitor.email) || visitor._id
                      ) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.duration,
                expression: "duration",
              },
            ],
            staticClass: "duration",
            attrs: { type: "number" },
            domProps: { value: _vm.duration },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.duration = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%", "margin-left": "10px" },
              attrs: { "show-search": "" },
              model: {
                value: _vm.unit,
                callback: function ($$v) {
                  _vm.unit = $$v
                },
                expression: "unit",
              },
            },
            _vm._l(_vm.remindDates, function (remindDate, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: remindDate } },
                [
                  _vm._v(
                    "\n                " + _vm._s(remindDate) + "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("span", { staticClass: "material-icons" }, [_vm._v("subject")]),
          _vm._v(" "),
          _c("a-input", {
            class: _vm.$t("calendar.subject"),
            attrs: { placeholder: _vm.$t("message.description") },
            model: {
              value: _vm.eventModalData.description,
              callback: function ($$v) {
                _vm.$set(_vm.eventModalData, "description", $$v)
              },
              expression: "eventModalData.description",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("span", { staticClass: "material-icons attach-icon" }, [
          _vm._v("attach_file"),
        ]),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-left": "10px" } }, [
          _c(
            "button",
            { staticClass: "attache_file_btn", on: { click: _vm.selectFile } },
            [_c("span", [_vm._v(_vm._s(_vm.$t("task.attachFiles")))])]
          ),
          _vm._v(" "),
          _vm.attachments.length > 0
            ? _c(
                "div",
                { staticClass: "attachments" },
                _vm._l(_vm.attachments, function (attachment, index) {
                  return _c("div", { key: index, staticClass: "attachment" }, [
                    _c("div", { staticClass: "left" }, [
                      _c("span", { staticClass: "filename" }, [
                        _vm._v(_vm._s(attachment.file.name)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "size" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("calendar.fileSizeKilobytes", {
                              size: attachment.newSize,
                            })
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.fileLoading === 100
                      ? _c(
                          "span",
                          {
                            staticClass: "material-icons",
                            staticStyle: {
                              "font-size": "16px",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteAttachment(index)
                              },
                            },
                          },
                          [_vm._v("delete")]
                        )
                      : _c("span", [_vm._v(_vm._s(_vm.fileLoading) + "%")]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("span", { staticClass: "material-icons lock-icon" }, [
            _vm._v("lock"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.eventModalData.visibility,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "visibility", $$v)
                },
                expression: "eventModalData.visibility",
              },
            },
            _vm._l(_vm.visibilities, function (visibility, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: visibility.value } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(visibility.label) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _c("span", { staticClass: "material-icons lock-icon" }, [
            _vm._v("calendar_today"),
          ]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.eventModalData.calendarId,
                callback: function ($$v) {
                  _vm.$set(_vm.eventModalData, "calendarId", $$v)
                },
                expression: "eventModalData.calendarId",
              },
            },
            _vm._l(_vm.supsisCalendars, function (calendar, index) {
              return _c(
                "a-select-option",
                { key: index, attrs: { value: calendar.value } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(calendar.label) +
                      "\n            "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("a", { attrs: { href: _vm.getLinkGoogle(), target: "_blank" } }, [
          _vm._v(_vm._s(_vm.$t("calendar.googleCalendarLink"))),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _c("a", { attrs: { href: _vm.getLinkYahoo(), target: "_blank" } }, [
          _vm._v(_vm._s(_vm.$t("calendar.yahooCalendarLink"))),
        ]),
      ]),
      _vm._v(" "),
      _vm.footerVisible && _vm.isSupsisEvent
        ? _c("div", { staticClass: "footer-action" }, [
            Object.keys(this.eventDetail).length > 0
              ? _c(
                  "span",
                  {
                    staticClass: "btn delete",
                    on: {
                      click: function ($event) {
                        return _vm.deleteEvent()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("calendar.delete")) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "btn",
                on: {
                  click: function ($event) {
                    return _vm.editOrCreateEvent()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.save")))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.customRepeatModal
        ? _c("CustomRepeat", {
            on: {
              close: function ($event) {
                _vm.customRepeatModal = false
              },
              save: function ($event) {
                _vm.customRecurrence = $event
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.deleteModal,
            cancelText: "Vazgeç",
            okText: _vm.$t("calendar.delete"),
            centered: "",
            footer: null,
          },
          on: {
            cancel: function ($event) {
              _vm.deleteModal = false
            },
          },
        },
        [
          _c("div", { staticClass: "delete-title" }, [
            _vm._v(_vm._s(_vm.$t("calendar.deleteRepeatEvent"))),
          ]),
          _vm._v(" "),
          _c(
            "a-radio-group",
            {
              staticStyle: { display: "flex", "flex-direction": "column" },
              model: {
                value: _vm.selectDeleteType,
                callback: function ($$v) {
                  _vm.selectDeleteType = $$v
                },
                expression: "selectDeleteType",
              },
            },
            [
              _c(
                "a-radio",
                {
                  staticStyle: { display: "flex" },
                  attrs: { value: "single" },
                },
                [_vm._v(" " + _vm._s(_vm.$t("calendar.thisEvent")) + " ")]
              ),
              _vm._v(" "),
              _c(
                "a-radio",
                { staticStyle: { display: "flex" }, attrs: { value: "after" } },
                [_vm._v(" " + _vm._s(_vm.$t("calendar.thisAndOtherEvent")))]
              ),
              _vm._v(" "),
              _c(
                "a-radio",
                { staticStyle: { display: "flex" }, attrs: { value: "all" } },
                [_vm._v(" " + _vm._s(_vm.$t("calendar.allEvent")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-btns" }, [
            _c(
              "span",
              {
                staticClass: "footer-btn",
                on: {
                  click: function ($event) {
                    _vm.deleteModal = false
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("calendar.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "footer-btn",
                on: {
                  click: function ($event) {
                    return _vm.deleteEventSelectType()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("calendar.ok")))]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }